<script>
	export let id = null;
	export let name = null;
	export let value = "";
	export let rows = null;
	export let label = null;
	export let sublabel = null;
	export let required = null;
	export let disabled = null;
	export let autoExpand = true;
	export let placeholder = null;
	export let break_text = true;
	export let maxlength = null;
</script>

{#if label !== null}
	<label for={id} class:isrequired={required}>
		{@html label}
		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}
	</label>
{/if}

<div class:grow_wrap={autoExpand} data-replicated-value={value} class:break_text>
	{#if autoExpand}
		<textarea {required} {disabled} {id} {name} {placeholder} {maxlength} bind:value class="form-control"></textarea>
	{:else}
		<textarea {required} {disabled} {id} {name} {placeholder} {rows} {maxlength} bind:value class="form-control"></textarea>
	{/if}
</div>

<style>
	.grow_wrap {
		display: grid;
	}

	.grow_wrap::after {
		content: attr(data-replicated-value) " ";
		white-space: pre-wrap;
		visibility: hidden;
	}

	textarea {
		resize: none;
		overflow: hidden;
	}

	textarea,
	.grow_wrap::after {
		border: 1px solid rgb(124, 133, 140);
		padding-top: 0.5rem;
		padding-right: 0.5rem;
		padding-bottom: 0.5rem;
		padding-left: 0.5rem;
		grid-area: 1 / 1 / 2 / 2;
		height: auto;
		min-height: 50px;
		font-family: inherit;
		font-size: 18px;
		line-height: 1.2;
	}

	textarea:focus {
		border-color: #e46937;
	}

	.grow_wrap.break_text textarea,
	.grow_wrap.break_text::after {
		word-break: break-all;
	}

	.isrequired > .required {
		color: red;
		margin-left: 0.25rem;
	}
</style>
